__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "plurall-tasks-web";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@plurall/elo-beta", "2.0.0-beta.523", () => (Promise.all([__webpack_require__.e(675), __webpack_require__.e(916), __webpack_require__.e(805), __webpack_require__.e(534), __webpack_require__.e(936)]).then(() => (() => (__webpack_require__(12453))))));
			register("@plurall/elo-v3", "0.21.0", () => (Promise.all([__webpack_require__.e(65), __webpack_require__.e(916), __webpack_require__.e(853)]).then(() => (() => (__webpack_require__(45065))))));
			register("@plurall/use-person-assistent", "1.0.9", () => (__webpack_require__.e(764).then(() => (() => (__webpack_require__(13764))))));
			register("@sentry/react", "7.119.1", () => (__webpack_require__.e(722).then(() => (() => (__webpack_require__(14722))))));
			register("axios", "1.20.0", () => (__webpack_require__.e(69).then(() => (() => (__webpack_require__(87069))))));
			register("client-oauth2", "4.3.3", () => (__webpack_require__.e(710).then(() => (() => (__webpack_require__(26710))))));
			register("graphql-tag", "2.12.6", () => (Promise.all([__webpack_require__.e(356), __webpack_require__.e(2)]).then(() => (() => (__webpack_require__(50356))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(556).then(() => (() => (__webpack_require__(5556))))));
			register("query-string", "5.1.1", () => (__webpack_require__.e(663).then(() => (() => (__webpack_require__(86663))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(40961))), 1);
			register("react-infinite-scroller", "1.2.6", () => (Promise.all([__webpack_require__.e(805), __webpack_require__.e(420)]).then(() => (() => (__webpack_require__(81420))))));
			register("react-responsive", "8.2.0", () => (__webpack_require__.e(988).then(() => (() => (__webpack_require__(17988))))));
			register("react-responsive", "9.0.2", () => (__webpack_require__.e(790).then(() => (() => (__webpack_require__(65790))))));
			register("react-router-dom-v5-compat", "6.30.4", () => (Promise.all([__webpack_require__.e(160), __webpack_require__.e(916), __webpack_require__.e(141)]).then(() => (() => (__webpack_require__(24160))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(876), __webpack_require__.e(805)]).then(() => (() => (__webpack_require__(30876))))));
			register("react/jsx-runtime", "18.3.1", () => (() => (__webpack_require__(74848))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(96540))), 1);
			register("snakecase-keys", "1.2.0", () => (__webpack_require__.e(694).then(() => (() => (__webpack_require__(99694))))));
			initExternal(69652);
			initExternal(55894);
			initExternal(78747);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};